/**
 * `/checkout` — the checkout panel, and the return target for a failed
 * payment.
 *
 * One `RouteObject`, so the file is singular. The chosen plan rides the URL
 * (`?plan=<planId>`) rather than a store slice, because a checkout panel that
 * forgot its plan on a refresh would be a panel a reader could not return to —
 * and this is the one route in the area a browser leaves and comes back to.
 *
 * No `loader`: the page component owns its reads, so there is one cache and
 * one invalidation story. Nothing is resolved before paint, which is correct
 * here — the panel's four compositions each depend on a read, and painting one
 * before the reads settle would flash the wrong one.
 */
import type { RouteObject } from 'react-router-dom';

export const checkoutRoute: RouteObject = {
  path: 'checkout',
  lazy: async () => {
    const { CheckoutPage } = await import('./Checkout');
    return { Component: CheckoutPage };
  },
};
